var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"a6c4130fe613f7ca2fb2e44ec4ec9ff43dc79eb3"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["everest@noissue"]={id:"a6c4130fe613f7ca2fb2e44ec4ec9ff43dc79eb3"};
      